import '@/types/common';
import { writable } from 'svelte/store';
const { subscribe, update } = writable({
    projectId: 0
});
const actions = {
    setProject: (id) => update(store => ({ ...store, projectId: id }))
};
const step = {
    subscribe,
    ...actions
};
export default step;
